import pick from 'lodash/pick';
import { Community } from '@cocoplatform/coco-rtc-shared';
import { httpClient } from '@cocoplatform/coco-rtc-client';
import React from 'react';
import { useHistory } from 'react-router-dom';
import InternalSpaceEditModal, {
  getRecommendedAvSettings,
} from 'components/space-edit-modal/InternalSpaceEditModal';
import { spaceCreatedEvt } from 'atoms/spaces';
import { useCommunityDetails } from 'atoms/community-details';

export default function NewSpaceModal(p: {
  communities?: Community[];
  defaultCommunityId?: string;
  onClose?: () => void;
  onSuccess?: () => void;
}) {
  const history = useHistory();
  const communityId = p.defaultCommunityId ?? p.communities?.[0]?.id;

  const { community } = useCommunityDetails({
    communityId,
    autoLoad: true,
  });

  const meetingMode =
    community?.corridorType === 'PERSONAL'
      ? 'everyone_online'
      : 'everyone_same_room';

  const avSettings = getRecommendedAvSettings(meetingMode);

  return (
    <InternalSpaceEditModal
      {...pick(p, ['defaultCommunityId', 'onClose'])}
      {...{
        onSubmit: submitSpace,
        defaultValues: {
          // spaceType: 'scratch_blocks',
          communityId: p.defaultCommunityId ?? p.communities?.[0]?.id,
          themes: [],
          meetingMode: 'everyone_same_room',
          openForOthers: true,
          ...avSettings,
        } as any,
      }}
    />
  );

  async function submitSpace(formData: FormData, input: any) {
    const { data: space } = await httpClient.post('/spaces', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    const { id } = space;
    spaceCreatedEvt.post({
      space,
    });
    p.onSuccess?.();
    history.push(`/app/dashboard/${input.communityId}/spaces/${id}`);
    return space;
  }
}
